import { Button, font, Popup } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled(Popup.EmptyContent)`
    position: relative;
    width: 410px;
    padding: 40px 50px;
    overflow: auto;
`;

export const Title = styled.div`
    ${font(16, '#000', 'semibold')};
    text-align: center;
    padding: 0 40px;
`;

export const ConfirmButton = styled(Button)`
    margin-top: 29px;
    width: 100%;
`;

export const ImageWrapper = styled.div`
    margin: 10px 0 30px;
    display: flex;
    justify-content: center;
`;
